import React from 'react';
import { useSources } from 'app/shared/sources';

export const ScimagoJournalRank: React.FC<{ id: string }> = ({ id }) => {
  const sources = useSources();
  const source = sources.get(id);
  return source && source.fields.scimagoJournalRank ? <>{source.fields.scimagoJournalRank['en-US']}</> : null;
};
